// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1qQZ5","select":"Header_select__2aWVI","clinic":"Header_clinic__24bVv"};